import ProfilePage from "../../../../../appl/view/components/profile/ProfilePage";

export default function ProfileTest() {

  return <div className='bg-cn-color-black-804'>
    <ProfilePage/>
  </div>
}